import React, { useContext, useEffect, useState } from "react";
import { ThemeContext } from "./ThemeProvider";
import { Tooltip, IconButton, Zoom } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Brightness4, Brightness7 } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  iconButton: {
    position: "fixed",
    bottom: theme.spacing(6),
    right: theme.spacing(6),
    height: "2.5rem",
    width: "2.5rem",
  },
  icon: {
    fontSize: "1.25rem",
  },
}));

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const classes = useStyles();

  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      clearTimeout(timer);
      setIsVisible(true);
      setTimer(setTimeout(() => {
        setIsVisible(false);
      }, 1500));
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timer);
    };
  }, [timer]);

  const handleMouseEnter = () => {
    clearTimeout(timer);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    setTimer(setTimeout(() => {
      setIsVisible(false);
    }, 1500));
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isVisible &&
        <Tooltip
          title={"Toggle theme"}
          placement="right"
          TransitionComponent={Zoom}
          style={{ zIndex: 1000 }}
        >
          <IconButton
            color="inherit"
            onClick={toggleTheme}
            aria-label={"Toggle theme"}
            className={classes.iconButton}
          >
            {theme === "light" ? (
              <Brightness4 className={classes.icon} />
            ) : (
              <Brightness7 className={classes.icon} />
            )}
          </IconButton>
        </Tooltip>
      }
    </div>
  );
};
